"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DAYS_IN_MONTH = void 0;
var DAYS_IN_MONTH = exports.DAYS_IN_MONTH = 28;